import { CombinationRulesService } from "~/entity/CombinationRules/api/service";

export const useCombinationRules = () => {
  const rulesGet = CombinationRulesService.GET.getRules;
  const ruleGetById = CombinationRulesService.GET.getRuleById;
  const placePostTypesGet = CombinationRulesService.GET.getPlacePostTypes;
  const rulesReportGet = CombinationRulesService.GET.getRulesReport;
  const filterDealersGet = CombinationRulesService.GET.getFilterDealers;
  const filterCategoriesGet = CombinationRulesService.GET.getFilterCategories;
  const filterPositionsGet = CombinationRulesService.GET.getFilterPositions;
  const ruleCreate = CombinationRulesService.POST.createRule;
  const rulesPrecheckAll = CombinationRulesService.POST.precheckAllRules;
  const rulesCheckAll = CombinationRulesService.POST.checkAllRules;
  const rulePut = CombinationRulesService.PUT.putRule;
  const ruleToggle = CombinationRulesService.PATCH.toggleRule;
  const ruleDelete = CombinationRulesService.DELETE.deleteRule;

  return {
    rulesGet,
    ruleGetById,
    placePostTypesGet,
    rulesReportGet,
    filterDealersGet,
    filterCategoriesGet,
    filterPositionsGet,
    ruleCreate,
    rulesPrecheckAll,
    rulesCheckAll,
    rulePut,
    ruleToggle,
    ruleDelete,
  };
};
